// extracted by mini-css-extract-plugin
export default {"brandPromo":"JH-z","carousel":"KH-z"};